<div mdbModal #ingresarDoc="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Editar Ajuste de Inventario Físico
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="ingresarDoc.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form autocomplete="off" [formGroup]="formHeader">
                    <div class="row align-items-center">
                        <div class="col dato" style="max-width: 200px">
                            <Strong class="title">Nro. Doc.</Strong>
                            <span class="value">{{movimiento?.codigo}}</span>
                        </div>

                        <div class="col" style="max-width: 250px">
                            <div class="md-form mb-0">
                                <mdb-date-picker [placeholder]="'Fecha Mov.'" [inline]="true" name="fechaMovimiento"
                                    [placeholder]="'Fecha de movimiento'" required formControlName="fechaMovimiento">
                                </mdb-date-picker>
                                <div *ngIf="
                                        formHeader.get('fechaMovimiento').invalid &&
                                        (formHeader.get('fechaMovimiento').dirty ||
                                        formHeader.get('fechaMovimiento').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('fechaMovimiento').hasError('required')">
                                        Ingrese fechaMovimiento
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="md-form">
                                <input value="" type="text" id="observ" class="form-control" placeholder="" #observ
                                    formControlName="observacion" />
                                <label for="observ">Observación</label>
                            </div>
                        </div>
                    </div>

                 
                </form>

                <div class="row" style="border-bottom: 1px solid #dee2e6">
                    <div class="col">
                        <h5 class="modal-title w-100 text-left" id="myModalLabel">
                            Ingreso de productos
                        </h5>
                    </div>
                </div>

                <form [formGroup]='formDetails' novalidate>
                    <div class="row align-items-center">
                        <div class="col" style="max-width: 200px">
                            <div class="md-form">
                                <input value="" type="text" id="codProduct" class="form-control" placeholder="000"
                                    required #codProduct formControlName="codigo" />
                                <label for="codProduct">Código de producto</label>
                                <div *ngIf="
                                    formDetails.get('codigo').invalid &&
                                    (formDetails.get('codigo').dirty ||
                                    formDetails.get('codigo').touched)
                                ">
                                    <mdb-error *ngIf="formDetails.get('codigo').hasError('required')">
                                        Ingrese código de producto
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex">
                            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                (click)="abrirModalSeleccionarProducto()">
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                            <h6 class="text-info" *ngIf="productoSeleccionado" style="display: contents">
                                {{ productoSeleccionado.descripcion}}
                            </h6>
                        </div>
                        <div class="col dato">
                            <div class="md-form">
                                <mdb-select [options]="optionsFormato" [filterEnabled]="true" [highlightFirst]="false"
                                    placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
                                <label>Formato</label>
                                <div *ngIf="
                                    formDetails.get('formato').invalid &&
                                    (formDetails.get('formato').dirty ||
                                    formDetails.get('formato').touched)
                                ">
                                    <mdb-error *ngIf="formDetails.get('formato').hasError('required')">
                                        Ingrese formato
                                    </mdb-error>
                                </div>
                            </div>
                        </div>

                        <div class="col">
                            <button type="button" mdbBtn color="info" mdbWavesEffect (click)="agregarProducto()">
                                Agregar
                            </button>
                        </div>
                    </div>
                </form>

                <table class="table table-striped table-hover table-sm align-middle"
                    *ngIf="detalleDocumento?.length > 0">
                    <thead class="grey lighten-2">
                        <tr>
                            <!-- <th scope="col">
                                <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
                            </th> -->
                            <th scope="col">SKU</th>
                            <th scope="col">Producto</th>
                            <th scope="col">Bodega</th>
                            <th scope="col">Rubro</th>
                            <th scope="col">Familia</th>
                            <th scope="col">Formato</th>
                            <th scope="col" class="text-center">Cantidad</th>
                            <!-- <th scope="col"></th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let doc of detalleDocumento">
                            <!-- <td>
                                <mdb-checkbox [checked]="doc.additionalInfo.checked"
                                    (change)='checkDetalle(doc.additionalInfo)'>
                                </mdb-checkbox>
                            </td> -->
                            <td>{{doc.sku}}</td>
                            <td>{{doc.producto_nombre}}</td>
                            <td>{{doc.bodega_nombre}}</td>
                            <td>{{doc.rubro_nombre}}</td>
                            <td>{{doc.familia_nombre}}</td>
                            <td>{{doc.formato_nombre}}</td>

                            <td class="text-center">
                                <div style="display: inline-block;">
                                    <input type="text" [id]="doc.additionalInfo.id"
                                        class="form-control toma-inventario__input-cantidad" required onlyNumbers min="0"
                                        (input)="onCantidadChange(doc, $event.target.value)"
                                        [(ngModel)]="doc.cantidad_contada" #cantidad="ngModel" />
                                    <!-- <mdb-error *ngIf="!cantidad.valid" style="position: inherit;">
                                        Ingrese cantidad
                                    </mdb-error> -->
                                </div>
                            </td>

                            <!-- <td>
                                <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                                    (click)="eliminarProducto(doc.additionalInfo.index)">
                                    <mdb-icon fas icon="trash"></mdb-icon>
                                </button>
                            </td> -->
                        </tr>
                    </tbody>
                    <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="detalleDocumento?.length > 0"></app-pagination>
                </table>
                <form autocomplete="off" [formGroup]="formFooter">
                <div class="row justify-content-start align-items-center">
                    <!-- <div class="col" style="max-width: 160px">
                        <button type="button" class="btn btn-warning waves-light" data-dismiss="modal" mdbWavesEffect
                            (click)="eliminarProductosSeleccionados()">
                            Eliminar
                        </button>
                    </div> -->
                    <!-- <div class="col" style="max-width: 400px">
                            <mdb-checkbox formControlName="encero">Dejar en 0 los productos no inventariados</mdb-checkbox>
                    </div> -->
                </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="ingresarDoc.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <div class="">
                    <!-- <button type="button" class="btn btn-success waves-light" mdbWavesEffect
                        (click)="generarArchivoExcel()">
                        Exportar a Excel
                    </button> -->
                    <app-api-button (click2)="guardar()" [processing]="processing">Guardar</app-api-button>
                    <!-- <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="guardar()">
                        Guardar
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
    (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>